// extracted by mini-css-extract-plugin
export default {"meals":"AvailableMeals_meals__MmhQZ","meals-appear":"AvailableMeals_meals-appear__jLQxc"};